import React, { Component, Fragment } from "react";
import { Button } from "../components/Button";
import { Paging } from "../components/Paging";
import { Table, TableHead, TableBody, Col, HeaderCell } from "../components/Table";
import { LoadingSpinner } from "../components/LoadingSpinner";
import "./SearchResults.css";
import { FormattedMessage } from "react-intl";
import MunicipalityContext from "../MunicipalityContext";

export class SearchResults extends Component {

  static contextType = MunicipalityContext;

  render() {
    const {
      changePage,
      currentPage,
      pageSize,
      results,
      searching,
      searchError,
      sortColumn,
      sortDirection,
      totalRows,
      updateSort,
      locale,
    } = this.props;

    const spinner = (
      <div className='spinnerContainer'>
        <LoadingSpinner />
      </div>
    );
    if (!searching && !results) return "";

    if (searchError) {
      return (
        <div className='searchError'>
          <FormattedMessage id='pestControlOperatorSearch.searchError' />
        </div>
      );
    }

    const municipalities = this.context;
    const municipalityNames = municipalities.reduce((obj, municipality) => {
      obj[municipality.kuntaKoodi] =
        locale === "fi" ? municipality.kuntaNimi : municipality.kuntaNimiSv;
      return obj;
    }, {});

    const paging = (
      <Paging
        itemsLength={totalRows}
        perPage={pageSize}
        activePage={currentPage}
        changePage={changePage}
      >
        {({ totalPages, activePage, goBack, goForward }) => (
          <div className='paging'>
            <Button link onClick={goBack} disabled={activePage === 0}>
              <FormattedMessage id='common.previous' />
            </Button>
            <div className='pagesCount'>
              {activePage + 1} / {totalPages || 1}
            </div>
            <Button link onClick={goForward} disabled={activePage >= totalPages - 1}>
              <FormattedMessage id='common.next' />
            </Button>
          </div>
        )}
      </Paging>
    );

    const drawResultsHeadingFinished = (
      <div className="resultHeading" aria-live="assertive">
        <FormattedMessage
          id="common.results"
          values={{
            results: <span className="resultCount">{totalRows}</span>,
          }}
        />
      </div>
    );

    const drawResultsHeadingSearching = (
      <div className='resultHeading'>
        <FormattedMessage id='common.searching' />
      </div>
    );

    const generateKey = row => {
      return `${row.nimi}${row.toimintaoikeus}${row.kuntakoodi}`;
    };

    return (
      <Fragment>
        {searching ? drawResultsHeadingSearching : drawResultsHeadingFinished}
        {paging}
        <Table>
          <TableHead sortColumn={sortColumn} sortDirection={sortDirection} updateSort={updateSort}>
            <HeaderCell name='nimi'>
              <FormattedMessage id='common.company' />
            </HeaderCell>
            <HeaderCell name='ytunnus'>
              <FormattedMessage id='common.businessId' />
            </HeaderCell>
            <HeaderCell name='kuntaKoodi'>
              <FormattedMessage id='common.municipality' />
            </HeaderCell>
            <HeaderCell name='toimipaikka'>
              <FormattedMessage id='common.office' />
            </HeaderCell>
            <HeaderCell name='vastuuhenkilo'>
              <FormattedMessage id='common.leader' />
            </HeaderCell>
          </TableHead>
          {searching ? (
            <tbody>
              <tr>
                <td colSpan='5'>{spinner}</td>
              </tr>
            </tbody>
          ) : (
            <TableBody rows={results}>
              {rows =>
                rows.map(row => (
                  <tr key={generateKey(row)}>
                    <Col label='common.company'>{row.nimi}</Col>
                    <Col label='common.businessId'>{row.ytunnus}</Col>
                    <Col label='common.municipality'>
                      {municipalityNames[row.kuntakoodi]}
                    </Col>
                    <Col label='common.office'>{row.toimipaikka}</Col>
                    <Col label='common.leader'>{row.vastuuhenkilo}</Col>
                  </tr>
                ))
              }
            </TableBody>
          )}
        </Table>
        {paging}
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/PestControlOperatorSearch/SearchResults.js